/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requirement_Go_To_DocumentsInputs */

const en_task_requirement_go_to_documents = /** @type {(inputs: Task_Requirement_Go_To_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to documents`)
};

const pt_br2_task_requirement_go_to_documents = /** @type {(inputs: Task_Requirement_Go_To_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para documentos`)
};

/**
* | output |
* | --- |
* | "Go to documents" |
*
* @param {Task_Requirement_Go_To_DocumentsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_go_to_documents = /** @type {((inputs?: Task_Requirement_Go_To_DocumentsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_Go_To_DocumentsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_go_to_documents(inputs)
	return pt_br2_task_requirement_go_to_documents(inputs)
});